import React, { useState, useEffect, useContext, useMemo, useId } from "react";
import { useRouter } from "next/router";
import { Context, XtLocale, Util } from "@xt/xtbase";
const { XtContext } = Context;
const { getUrl } = Util;
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import styles from "./index.module.less";
import { resolveCfdSymbol } from "../utils/getCfdSymbol";
import { useNavStore } from "../NavStoreContext";
import { observer } from "mobx-react-lite";

// 所有图标已使用 SVG，不再需要图片资源

// HOME 图标 - 使用 SVG
const IconHome = ({ active }) => {
  const strokeColor = active ? "#B9F78A" : "#999";
  const fillColor = active ? "#B9F78A" : "none";
  
  if (active) {
    // 激活状态：使用填充样式
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
        <path d="M5.66699 0.764587C6.92521 -0.210112 8.93296 -0.260122 10.2412 0.656189L15.042 4.01459C15.9586 4.6563 16.6836 6.04004 16.6836 7.16498V12.8144C16.6836 14.9394 14.958 16.665 12.833 16.665H3.84961C1.72485 16.6648 0.000102107 14.9314 0 12.8066V7.05658C0 6.00676 0.658085 4.6735 1.49121 4.02338L5.66699 0.764587ZM8.1543 9.08197C7.7102 9.08197 7.3418 9.45037 7.3418 9.89447V13.1445C7.34207 13.5884 7.71036 13.956 8.1543 13.956C8.59818 13.9559 8.96653 13.5883 8.9668 13.1445V9.89447C8.9668 9.45041 8.59834 9.08204 8.1543 9.08197Z" fill={fillColor}/>
      </svg>
    );
  } else {
    // 非激活状态：使用新的 SVG（stroke 样式）
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M3.02499 5.8667C2.27499 6.45003 1.66666 7.6917 1.66666 8.63337V14.8084C1.66666 16.7417 3.24166 18.325 5.17499 18.325H14.825C16.7583 18.325 18.3333 16.7417 18.3333 14.8167V8.75003C18.3333 7.7417 17.6583 6.45003 16.8333 5.87503L11.6833 2.2667C10.5167 1.45003 8.64166 1.4917 7.51666 2.3667L3.02499 5.8667Z" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10 14.9917V12.4917" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }
};

// Market 图标（底部栏第二项；Prop Trading 下线时恢复行情入口）
const IconMarket = ({ active }) => {
  const strokeColor = active ? "#B9F78A" : "#999";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M5.41699 18.3333V12.5" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.41699 4.16663V1.66663" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.583 18.3334V15.8334" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.583 7.49996V1.66663" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.91699 10.8333C7.91699 11.75 7.50033 12.5 6.25033 12.5H4.58366C3.33366 12.5 2.91699 11.75 2.91699 10.8333V5.83329C2.91699 4.91663 3.33366 4.16663 4.58366 4.16663H6.25033C7.50033 4.16663 7.91699 4.91663 7.91699 5.83329V10.8333Z" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17.083 14.1667C17.083 15.0833 16.6663 15.8333 15.4163 15.8333H13.7497C12.4997 15.8333 12.083 15.0833 12.083 14.1667V9.16667C12.083 8.25 12.4997 7.5 13.7497 7.5H15.4163C16.6663 7.5 17.083 8.25 17.083 9.16667V14.1667Z" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

/* Prop Trading 备用：恢复底部栏第二项为 /proptrading 时启用 IconPropTrading + tab key propTrading
const IconPropTrading = ({ active }) => {
  const fillColor = active ? "#B9F78A" : "#999";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fill={fillColor}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 1.5a8.5 8.5 0 1 1 0 17.001A8.5 8.5 0 0 1 10 1.5m0 1.433A7.075 7.075 0 0 0 2.933 10a7.07 7.07 0 0 0 8.446 6.932 7.067 7.067 0 0 0-1.379-14m3.603 7.767a.717.717 0 0 1 0 1.433H8.128l.214.215A.716.716 0 1 1 7.33 13.36l-1.437-1.437a.72.72 0 0 1-.156-.78.72.72 0 0 1 .661-.443zM12.16 6.42a.72.72 0 0 1 .509.22l1.438 1.436a.72.72 0 0 1-.108 1.104.7.7 0 0 1-.398.12H6.398a.717.717 0 0 1 0-1.433h5.474l-.215-.215a.717.717 0 0 1-.01-1.021.72.72 0 0 1 .513-.21"
      />
    </svg>
  );
};
*/

// Trade 图标 - 使用 div 背景 + SVG 图标
const IconTrade = ({ active }) => {
  return (
    <div className={styles["trade-icon-wrapper"]}>
      <div className={styles["trade-icon-bg"]}></div>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={styles["trade-icon-foreground"]}>
        <path d="M7.5163 7.51624C10.1579 7.72456 12.2746 9.8415 12.4831 12.483C12.4914 12.6247 12.4997 12.775 12.4997 12.9166C12.4997 15.9082 10.0752 18.3334 7.08368 18.3336C4.09201 18.3336 1.66669 15.9083 1.66669 12.9166C1.66669 9.92496 4.09202 7.49963 7.08368 7.49963C7.22511 7.49965 7.37486 7.50792 7.5163 7.51624ZM16.9079 14.7506C17.4328 14.2257 18.3324 14.6001 18.3327 15.3414V17.5006C18.3325 17.9588 17.9579 18.3336 17.4997 18.3336H15.3415C14.5999 18.3336 14.2333 17.4338 14.7497 16.9088L16.9079 14.7506ZM12.9167 1.66663C15.9084 1.66663 18.3337 4.09195 18.3337 7.08362C18.3335 9.80014 16.333 12.0416 13.7331 12.4332V12.3834C13.4748 9.15009 10.8498 6.52457 7.59149 6.26624H7.56708C7.95893 3.66646 10.2002 1.66664 12.9167 1.66663ZM4.6579 1.66663C5.39956 1.66663 5.76636 2.56643 5.24969 3.09143L3.09149 5.24963C2.56649 5.77463 1.66669 5.3995 1.66669 4.65784V2.49963C1.66686 2.04156 2.04162 1.6668 2.49969 1.66663H4.6579Z" fill="#26272D"/>
      </svg>
    </div>
  );
};

// AI Trading 图标（AILAB.svg）
const IconAITrading = ({ active }) => {
  const fillColor = active ? "#B9F78A" : "#999";
  const clipId = useId().replace(/:/g, "");
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <g clipPath={`url(#${clipId})`}>
        <path
          fill={fillColor}
          d="m17.491 6.009 1.17.15c.62.078 1.088.648 1.044 1.272l-.678 9.575a1.06 1.06 0 0 1-1.204.986l-1.17-.15a1.213 1.213 0 0 1-1.044-1.273l.678-9.574a1.06 1.06 0 0 1 1.204-.986m-7.042-4.48c.178 0 .332.124.37.298l3.342 15.559a.378.378 0 0 1-.369.457H11.06a.38.38 0 0 1-.37-.3L8.537 7.499c-.078-.364-.58-.407-.72-.061l-2.535 6.338a.378.378 0 0 0 .351.518h2.332c.249 0 .43.236.364.477l-.76 2.794a.38.38 0 0 1-.365.279H.368a.378.378 0 0 1-.351-.515L6.069 1.77a.38.38 0 0 1 .351-.242zM18.187 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

// Assets 图标 - 使用 SVG
const IconAssets = ({ active }) => {
  const strokeColor = active ? "#B9F78A" : "#999";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10.8333 9.29156H5.83331" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1.66669 9.29176V5.44176C1.66669 3.74176 3.04169 2.36676 4.74169 2.36676H9.42502C11.125 2.36676 12.5 3.42509 12.5 5.12509" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.1167 11.8166C14.325 12.5916 15.0917 13.0833 15.8917 13.0833H16.6667V14.2916C16.6667 16.1333 15.175 17.6249 13.3334 17.6249H5.00002C3.15835 17.6249 1.66669 16.1333 1.66669 14.2916V8.45827C1.66669 6.61661 3.15835 5.12494 5.00002 5.12494H13.3334C15.1667 5.12494 16.6667 6.62494 16.6667 8.45827V9.66656H15.7667C15.3 9.66656 14.875 9.84993 14.5667 10.1666C14.15 10.5666 13.95 11.1832 14.1167 11.8166Z" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.3333 12.2334C18.3333 12.7001 17.9499 13.0834 17.4749 13.0834H15.8666C14.9666 13.0834 14.1416 12.4251 14.0666 11.5251C14.0166 11.0001 14.2166 10.5084 14.5666 10.1668C14.8749 9.85011 15.2999 9.66675 15.7666 9.66675H17.4749C17.9499 9.66675 18.3333 10.0501 18.3333 10.5168V12.2334Z" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

function BottomBar(props) {
  const [appState] = useContext(XtContext);
  const { fund } = useNavStore();
  const router = useRouter();
  const t = useTranslation();
  const [activeTab, setActiveTab] = useState("");
  // 兜底为 U 本位，避免未拉取 IP 前点击跳到现货；有 fiatCurrencyIds/IP 法币时会更新为法币
  const [cfdMarket, setCfdMarket] = useState("btc_usdt_cfd");
  const [tradeIconShake, setTradeIconShake] = useState(false);
  const logRouterDebug = (type, detail) => {
    if (typeof window === "undefined" || typeof window.__routerDebugLog !== "function") {
      return;
    }
    window.__routerDebugLog(type, detail);
  };

  const recommendedCurrencyKey = useMemo(() => {
    return (fund?.recommendedCurrencyList || [])
      .map((item) => `${item?.currency || ""}:${(item?.plates || []).join(",")}`)
      .join("|");
  }, [fund?.recommendedCurrencyList, fund?.recommendedCurrencyListMd5]);

  useEffect(() => {
    let cancelled = false;
    resolveCfdSymbol({
      fiatCurrencyIds: appState?.userInfo?.fiatCurrencyIds,
      loginStatus: appState?.loginStatus,
    }).then((symbol) => {
      if (!cancelled) setCfdMarket(symbol);
    });
    return () => {
      cancelled = true;
    };
  }, [appState?.userInfo?.fiatCurrencyIds, appState?.loginStatus, recommendedCurrencyKey]);

  // 根据路由判断当前激活的 tab
  useEffect(() => {
    if (typeof window === "undefined") return;

    let pathname = window.location.pathname;
    
    // 移除 locale 前缀
    if (pathname.startsWith("/" + XtLocale.intl.locale)) {
      pathname = pathname.substring(("/" + XtLocale.intl.locale).length);
    }

    // 判断激活的 tab
    if (pathname === "/" || pathname === "") {
      setActiveTab("home");
    } else if (/^\/market($|[\/\?#])/.test(pathname)) {
      setActiveTab("market");
    } else if (/^\/(trade|tradePro|margin|marginPro|cfd|futures)($|[\/\?#])/.test(pathname)) {
      setActiveTab("trade");
    } else if (/^\/(aicopy)($|[\/\?#])/.test(pathname)) {
      setActiveTab("aiTrading");
    } else if (/^\/(wallet|account)($|[\/\?#])/.test(pathname)) {
      setActiveTab("assets");
    } else {
      setActiveTab("");
    }
  }, [router.asPath, router.locale]);

  // Tab 配置
  const tabs = [
    {
      key: "home",
      label: t("header.derivativesOverview2") || t("price.homePage") || "Home",
      icon: IconHome,
      path: "/",
    },
    {
      key: "market",
      label: t("header.markets"),
      icon: IconMarket,
      path: "/market",
    },
    {
      key: "trade",
      label: t("header.trading"), // 使用 header.trading (交易/Trading)
      icon: IconTrade,
      getPath: () => `/futures/contract/${cfdMarket}`, // 优先用户绑定币种(fiatCurrencyIds)，否则按 IP 获取 CFD 交易对
    },
    {
      key: "aiTrading",
      label: t("header.aicopy"), // 使用 header.aicopy (AI跟单/AI Trading)
      icon: IconAITrading,
      path: "/aicopy",
    },
    {
      key: "assets",
      label: t("header.wallet"), // 底部栏：钱包（与顶栏 header.asset 资产/Funds 区分）
      icon: IconAssets,
      path: "/wallet/account/overview",
    },
  ];


  return (
    <div className={styles["bottom-bar"]} data-app-bottom-tab="">
      <div className={styles["bottom-bar__container"]}>
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.key;
          // 支持动态路径函数
          const path = typeof tab.getPath === "function" ? tab.getPath() : tab.path;
          const isInternalRoute = ["home", "market", "trade", "aiTrading"].includes(tab.key);
          const href = isInternalRoute ? path : getUrl(path);

          const itemClassName = `${styles["bottom-bar__item"]} ${isActive ? styles["bottom-bar__item--active"] : ""}`;
          const itemContent = (
            <>
              <div className={`${styles["bottom-bar__icon"]} ${tab.key === "trade" && tradeIconShake ? styles["bottom-bar__icon--shake"] : ""}`}>
                <Icon active={isActive} />
              </div>
              <div className={styles["bottom-bar__label"]}>{tab.label}</div>
            </>
          );

          if (isInternalRoute) {
            const handleInternalRoute = () => {
              if (router.asPath === path) {
                logRouterDebug("bottomBar.sameRoute", {
                  tabKey: tab.key,
                  path,
                });
                return;
              }

              logRouterDebug("bottomBar.click", {
                tabKey: tab.key,
                path,
                currentAsPath: router.asPath,
              });

              if (tab.key === "trade") {
                setTradeIconShake(true);
                setTimeout(() => setTradeIconShake(false), 300);
                if (typeof navigator !== "undefined" && navigator.vibrate) {
                  navigator.vibrate(50);
                }
              }
              router.push(path);
            };

            return (
              <button key={tab.key} type="button" className={itemClassName} onClick={handleInternalRoute}>
                {itemContent}
              </button>
            );
          }

          return (
            <a key={tab.key} href={href} className={itemClassName}>
              {itemContent}
            </a>
          );
        })}

      </div>
    </div>
  );
}
export default observer(BottomBar);
